import {Field} from 'formik';
import React, {ReactElement} from 'react';
import {NxFormikProps} from '../../../shared/model/NxComponents.model';
import NxSwitch, {NxSwitchProps} from './NxSwitch';

export type NxFormikSwitchProps = Omit<NxSwitchProps, NxFormikProps> & {
  name: string;
  validate?: (value: boolean) => string | void | Promise<string | void>;
};

export const NxFormikSwitch = (props: NxFormikSwitchProps): ReactElement =>
  <Field type='checkbox' as={NxSwitch} {...props} />;
